<mat-card class="card-container mat-elevation-z8" [ngStyle]="styles">
	<ng-content></ng-content>
</mat-card>
